import cookie from 'react-cookie';
import isNumber from 'lodash/isNumber';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import isPlainObject from 'lodash/isPlainObject';
import reduce from 'lodash/reduce';
import assign from 'lodash/assign';
import forEach from 'lodash/forEach';
import config from '../config';
import * as cookies from '../constants/cookies';

export const cookieNameToConsentCategoryMap = reduce(
  cookies,
  (map, { name, consentCategory }) => assign(map, { [name]: consentCategory }),
  {},
);

const dateComponentsToSecondsMultipliersMap = {
  days: 24 * 60 * 60,
  hours: 60 * 60,
  minutes: 60,
  seconds: 1,
};

export function dateComponentToSeconds(dateComponents) {
  return reduce(
    dateComponents,
    (totalSeconds, baseValue, componentKey) => {
      const multiplier = dateComponentsToSecondsMultipliersMap[componentKey];

      if (multiplier) {
        return totalSeconds + baseValue * multiplier;
      }

      return totalSeconds;
    },
    0,
  );
}

export function getMaxAge(daysOrDateComponents) {
  if (isNumber(daysOrDateComponents)) {
    return dateComponentToSeconds({ days: daysOrDateComponents });
  }

  if (isPlainObject(daysOrDateComponents)) {
    return dateComponentToSeconds(daysOrDateComponents);
  }

  if (isUndefined(daysOrDateComponents) || isNull(daysOrDateComponents)) {
    return Math.floor((config.cookies.permanentExpiration - Date.now()) / 1000);
  }

  return 0;
}

export function getCookie(cookieName) {
  return cookie.load(cookieName);
}

export function canSaveCookie(cookieName) {
  const activeCookieConsentCategories = getCookie(
    cookies.activeConsentCategoriesCookie.name,
  );
  const cookieConsentCategory = cookieNameToConsentCategoryMap[cookieName];

  return (
    !activeCookieConsentCategories ||
    activeCookieConsentCategories.includes(cookieConsentCategory)
  );
}

export function setCookie(cookieName, daysOrDateComponents, value = true) {
  if (!canSaveCookie(cookieName)) {
    return;
  }

  cookie.save(cookieName, value, {
    path: '/',
    maxAge: getMaxAge(daysOrDateComponents), // maxAge is a `seconds` value
  });
}

export function removeCookie(cookieName) {
  cookie.remove(cookieName, { path: '/' });
}

export function removeInactiveConsentCategoryCookies() {
  forEach(cookieNameToConsentCategoryMap, (consentCategory, cookieName) => {
    if (!canSaveCookie(cookieName)) {
      removeCookie(cookieName);
    }
  });
}
